<template>
  <BasePageContent>
    <ManufacturerDetail :uuid="uuid"></ManufacturerDetail>
  </BasePageContent>
</template>

<script>
import ManufacturerDetail from "@/components/ui/manufacturer/ManufacturerDetail.vue";
export default {
  components: { ManufacturerDetail },
  props: {
    uuid: {
      type: String,
    },
  },
};
</script>